module.exports = __webpack_public_path__ + "static/media/17_tn.353a5386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/17_tn.jpg
// module id = 326
// module chunks = 0